<template>
    <div>
        <Auth>
            <img alt="Vue logo" src="../assets/logo.png">
            <h1>FHK Report Online Storage</h1>
            <StorageTool/>

            <template #login-error="{errorMessage}">
                <login-error :errorMessage="errorMessage"></login-error>
            </template>

            <template #login-progress>
                <div>Initializing...</div>
            </template>
        </Auth>
    </div>
</template>

<script>
    // @ is an alias to /src
    import StorageTool from '@/components/StorageTool.vue'
    import Auth from "@/components/Auth.vue";
    import LoginError from "@/components/LoginError.vue";

    export default {
        name: 'Teams',
        components: {
            StorageTool,
            Auth,
            LoginError,
        }
    }
</script>
